export const RETURN_COND_LIST = 'RETURN_COND_LIST';
export const RETURN_COND_ADD_SUCCESS = 'RETURN_COND_ADD_SUCCESS';
export const RETURN_COND_EDIT_SUCCESS = 'RETURN_COND_EDIT_SUCCESS';
export const RETURN_COND_LOADER = 'RETURN_COND_LOADER';
export const RETURN_COND_CRUD = 'RETURN_COND_CRUD';
export const TOGGLE_VIEW_EDIT = 'TOGGLE_VIEW_EDIT';
